module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Readers love")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("D.W. M")]), _c('span', {
    staticClass: "t3"
  }, [_vm._v("ARCHWELL")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("Even the Innocent")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“I really, thoroughly enjoyed this book. I was somewhat blown away, but more out of the fact that I was pleasantly surprised just how much I enjoyed this one.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("—MM Good Book Reviews")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("All That Heaven Will Allow")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“This story honestly kept me turning the page, wanting to know the pair’s fate. Mr. Marchwell doesn’t fail to answer that… DW Marchwell’s seems a contemporary romance author well worth following.”")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("—GLBT Bookshelf")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“This is a well written story with strong characters who will grab you from the beginning.”")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("—Literary Nymphs Reviews")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("“Jimmy and Derek’s story is really quite romantic… I really liked it”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("—The Blogger Girls")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47993f62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/002.vue
// module id = 57
// module chunks = 0